import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPDesktopMarxentConfigurator from 'components/consumer/modular-configurator/PDPMarxentConfigurator';
import PDPMobileConfigurationPhotoGalleryUI from './PDPMobileConfigurationPhotoGalleryUI';
const PDPMobileConfigurationPhotoGalleryInner = t0 => {
  const $ = _c(20);
  const {
    slug,
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    marxentPostHogFlag: t3,
    hideMarxent: t4,
    unavailableFabric: t5
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const marxentPostHogFlag = t3 === undefined ? false : t3;
  const hideMarxent = t4 === undefined ? true : t4;
  const unavailableFabric = t5 === undefined ? false : t5;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const t6 = !pdpIsModularBYOProduct;
  let t7;
  if ($[0] !== t6) {
    t7 = {
      skip: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let modularPhotosData = useModularPDPPhotos(null, slug, t7);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    loading: cylindoLoading,
    shouldShowDimensionThumbnail,
    upholsteryKey
  } = usePDPCylindoViewer();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  if (photosLoading || cylindoLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    let t8;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[2] = t8;
    } else {
      t8 = $[2];
    }
    return t8;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    configurationPhotos,
    isConfigFlipped,
    enableCrops
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  if (!configurationPhotos.length) {
    return null;
  }
  let t8;
  if ($[3] !== configurationPhotos || $[4] !== cylindoFeatures || $[5] !== enableCrops || $[6] !== hideMarxent || $[7] !== isConfigFlipped || $[8] !== isCylindoAvailable || $[9] !== isEditOrder || $[10] !== marxentPostHogFlag || $[11] !== name || $[12] !== pdpIsModularBYOProduct || $[13] !== pdpSelectedCustomizerTab || $[14] !== shouldShowDimensionThumbnail || $[15] !== slug || $[16] !== unavailableFabric || $[17] !== upholsteryKey || $[18] !== viewGalleryImageEvent) {
    t8 = marxentPostHogFlag === "test" && pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : <PDPMobileConfigurationPhotoGalleryUI cylindoFeatures={cylindoFeatures} enableCrops={enableCrops} isConfigFlipped={isConfigFlipped} isCylindoAvailable={isCylindoAvailable} isEditOrder={isEditOrder} photos={configurationPhotos} productName={name} showDecideLaterOverlay={pdpSelectedCustomizerTab === "decide-later"} viewGalleryImageEvent={viewGalleryImageEvent} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} upholsteryKey={upholsteryKey} />;
    $[3] = configurationPhotos;
    $[4] = cylindoFeatures;
    $[5] = enableCrops;
    $[6] = hideMarxent;
    $[7] = isConfigFlipped;
    $[8] = isCylindoAvailable;
    $[9] = isEditOrder;
    $[10] = marxentPostHogFlag;
    $[11] = name;
    $[12] = pdpIsModularBYOProduct;
    $[13] = pdpSelectedCustomizerTab;
    $[14] = shouldShowDimensionThumbnail;
    $[15] = slug;
    $[16] = unavailableFabric;
    $[17] = upholsteryKey;
    $[18] = viewGalleryImageEvent;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
PDPMobileConfigurationPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  slug: PropTypes.string
};
const PDPMobileConfigurationPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPMobileConfigurationPhotoGalleryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileConfigurationPhotoGallery;